import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function IndustriesSection() {
  const { i18n } = useTranslation();
  const { industries } = getLandingContent(i18n.language);

  return (
    <section id="industries" className="py-20 md:py-28 bg-white">
      <div className="px-6 md:px-10 lg:px-16">
        <p className="text-red-600 text-sm font-medium tracking-widest uppercase mb-4 md:mb-6">
          {industries.eyebrow}
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 md:mb-6 max-w-4xl leading-tight">
          {industries.title}
        </h2>
        <p className="text-base md:text-lg text-gray-500 max-w-2xl mb-14 md:mb-20 leading-relaxed">
          {industries.subtitle}
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {industries.items.map((industry) => (
            <div
              key={industry.id}
              className="group relative rounded-lg overflow-hidden aspect-[4/3] cursor-pointer shadow-soft hover:shadow-card-hover transition-shadow duration-300"
            >
              <img
                src={industry.image}
                alt={industry.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                width={400}
                height={300}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-gray-900/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-white leading-snug">
                  {industry.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
